import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "82d4a518-c600-445d-ab53-696fb28fea8c",
    authority: "https://login.microsoftonline.com/fa7fec11-41f6-42c0-bbfc-38ce489a9397",
    redirectUri: "https://market.figk-12.com",
    postLogoutRedirectUri: "https://market.figk-12.com",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL]', message);
            return;
          case LogLevel.Info:
            console.info('[MSAL]', message);
            return;
          case LogLevel.Verbose:
            console.debug('[MSAL]', message);
            return;
          case LogLevel.Warning:
            console.warn('[MSAL]', message);
            return;
          default:
            return;
        }
      },
    },
    allowNativeBroker: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "profile", "email", "openid"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
